<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tkHwSG/tc-custom/9781453266106.jpg?1733107199192" alt="This image is the cover for the book Cavanaugh Quest"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cavanaugh Quest
      </h1>
      <p class="bookDescription body article font2">
        <b>Edgar Award nominee: Backwoods treachery links a string of grisly Minnesota murders</b><br/> Reporter Paul Cavanaugh is coming home from an afternoon tennis match when he sees an ambulance outside his building’s door. A half hour earlier, the mild-mannered Larry Blankenship walked into the lobby, said hello to the doorman, and blew his brains out in front of the elevator bank, leaving behind a note apologizing for the mess. Cavanaugh retreats to his apartment to forget this disturbing scene, thinking the story is over when the police take away the body. But the suicide is only the beginning. A knot of death is tied tight around Blankenship’s wife, Kim, an ice-cold beauty from the backwoods of northern Minnesota. As he investigates the string of deaths, Cavanaugh discovers a decades-old atrocity that may explain why the men who know Kim vanish faster than a sunny day in Minneapolis.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thomas Gifford
      </h2>
      
      <p class="authorDescription body article">Thomas Gifford (1937&ndash;2000) was a bestselling author of thriller  novels. Born in Dubuque, Iowa, he moved to Minnesota after graduating  from Harvard. After eight years as a traveling textbook salesman, he  wrote <i>Benchwarmer Bob</i> (1974), a biography of Minnesota Vikings defensive end Bob Lurtsema. <i>The Wind Chill Factor</i> (1975), a novel about dark dealings among ex-Nazis, introduced John Cooper, a character Gifford would revisit in <i>The First Sacrifice</i> (1994). <i>The Wind Chill Factor</i> was one of several books Gifford set in and around Minneapolis.&#160;Gifford won an Edgar Award nomination for <i>The Cavanaugh Quest</i> (1976). <i>The Glendower Legacy</i> (1978), a story about an academic who discovers that George Washington may have been a British spy, was adapted for the film <i>Dirty Tricks</i> (1981), starring Elliott Gould. In the 1980s Gifford wrote suspense  novels under the pen names Thomas Maxwell and Dana Clarins. In 1996 he  moved back to Dubuque to renovate his childhood home. He died of cancer  in 2000. <BR><BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9f3bfaae